/* Newsletter archive — "Vis flere" loads the next pagination page and merges
   its year groups into the existing list, so all newsletters end up in one
   continuous list grouped by year. */
(function () {
  var btn = document.querySelector('[data-load-more]');
  var groups = document.querySelector('[data-archive-groups]');
  if (!btn || !groups) return;

  btn.addEventListener('click', async function () {
    var nextPage = parseInt(btn.dataset.nextPage, 10);
    var totalPages = parseInt(btn.dataset.totalPages, 10);

    btn.setAttribute('disabled', 'disabled');
    btn.textContent = btn.dataset.loadingLabel || 'Laster…';

    // Fetch the next page of this same URL (preserves ?view= in preview).
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(nextPage));

    try {
      var res = await fetch(url.toString());
      if (!res.ok) throw new Error('Request failed');
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGroups = doc.querySelectorAll('[data-archive-groups] .ubevisst-nl-archive__year-group');

      newGroups.forEach(function (group) {
        var year = group.getAttribute('data-year');
        var existing = groups.querySelector('.ubevisst-nl-archive__year-group[data-year="' + year + '"]');
        if (existing) {
          // Year already shown — append its items to the existing list.
          var targetList = existing.querySelector('.ubevisst-nl-archive__list');
          group.querySelectorAll('.ubevisst-nl-archive__item').forEach(function (item) {
            targetList.appendChild(item);
          });
        } else {
          groups.appendChild(group);
        }
      });

      var following = nextPage + 1;
      if (following > totalPages) {
        btn.parentNode.removeChild(btn);
      } else {
        btn.dataset.nextPage = String(following);
        btn.removeAttribute('disabled');
        btn.textContent = btn.dataset.label || 'Vis flere';
      }
    } catch (e) {
      btn.removeAttribute('disabled');
      btn.textContent = btn.dataset.label || 'Vis flere';
    }
  });
})();
